// extracted by mini-css-extract-plugin
module.exports = {"Login":"ky_a"};